import React from 'react'
import styles from './NotFoundPage.module.css'
import Icon from '../../components/Icon'
import { Link } from 'react-router-dom'
import { MAIN_PAGE } from '../../router/paths'
import { Helmet } from 'react-helmet'
import cn from 'classnames';

export default function NotFoundPage() {
  return (
    <div className={styles.page}>
      <Helmet>
        <title>404 | Восток Строй</title>
        {/* <meta name="description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta name="keywords" content="недвижимость, девелопер, Каспийск, новостройки, квартиры" /> */}
        <meta name="author" content="Восток Строй" />
        <meta name="robots" content="noindex, nofollow" />
        {/* <link rel="canonical" href="https://vostokstroy.com/" /> */}

        {/* <meta property="og:title" content="Ведущему девелоперу Каспийска — 10 лет" />
        <meta property="og:description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." /> */}
        {/* <meta property="og:image" content="https://vostokstroy.com/open-graphs/main-opengraph.jpg" /> */}
        {/* <meta property="og:url" content="https://vostokstroy.com/" /> */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Восток Строй" />

        <meta name="twitter:card" content="summary_large_image" />
        {/* <meta name="twitter:title" content="Ведущему девелоперу Каспийска — 10 лет" />
        <meta name="twitter:description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." /> */}
        {/* <meta name="twitter:image" content="https://vostokstroy.com/open-graphs/main-opengraph.jpg" /> */}

        <link rel="icon" type="image/svg+xml" href="/favicons/main-fav-32x32.svg" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicons/main-fav-16x16.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicons/main-fav-32x32.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/favicons/main-apple-touch-icon-180x180.png" />
        <link rel="icon" type="image/png" sizes="180x180" href="/favicons/main-fav-180x180.png" />
      </Helmet>
      <div className={styles.wrapper}>
          <Icon name='iconNotFound' width='160' height='176'></Icon>
          <div className={styles.text}>
              <h3 className={styles.head}>Ничего не найдено</h3>
              <p className={cn('text_body_b1', styles.description)}>Видимо, такой страницы не&nbsp;существует или она еще не&nbsp;создана</p>
          </div>
          <Link to={MAIN_PAGE} className={cn('text-2-bold_font', styles.button)}>На главную</Link>
      </div>
    </div>
  )
}
